<template>
  <!-- 编辑修改乘机人 修改出行人-->
  <div>
    <van-popup
      v-model="isShow"
      lock-scroll
      lazy-render
      position="right"
      class="full-height full-width bg-gray"
      close-on-popstate
      :close-on-click-overlay="false"
      :get-container="getContainer"
    >
      <div class="full-height">
        <ld-header @click-left="toggle">
          <span v-if="psgInfo.id">
            {{ $t('B066','修改常旅客') }}
          </span>
          <span v-else>
            {{ $t('B033','新增常旅客') }}
          </span>

          <ld-icon
            v-if="psgInfo.id"
            slot="right"
            type="iconqingkonglishijilu"
            @click="deletePsg"
          />
        </ld-header>


        <van-cell-group class="mt5">
          <van-row class="pad8">
            <van-row
              class="round-sm pad8 orange bg-lightYellow font12"
              style="line-height: 20px"
            >
              <span v-if="psgInfo.passed">
                核验状态 : 已通过<br>
                <span class="deep-gray">该乘客已通过核验，姓名及证件类型不可在线编辑。</span>
              </span>
              <span v-else>温馨提示：应疫情防控需求，乘客须提供本人手机号进行购票，手机号有误或填写他人手机号会导致购票失败，未成年人/老人等重点旅客可填写亲友手机号。</span>
            </van-row>
          </van-row>

          <van-field
            :label="$t('C114','乘客类型')"
            v-model="psgTypeName"
            input-align="left"
            readonly
          />

          <van-field
            placeholder="与乘客证件姓名一致"
            v-model="psgInfo.name"
            :disabled="!!psgInfo.id && psgInfo.checkStatus == 0"
            input-align="left"
          >
            <template #label>
              <span style="margin-right: 15px;">{{ $t('D007','姓名') }}</span>
              <van-icon
                class="main-color"
                name="question-o"
                @click="psgNameDescShow = true"
              />
            </template>

            <template
              v-if="!psgInfo.id"
              #button
            >
              <van-icon
                class="main-color"
                name="user-circle-o"
                size="24"
                @click="$refs.empList.toggle({ index: 1 })"
              />
            </template>
          </van-field>

          <van-field
            :label="$t('D003','证件类型')"
            v-model="psgInfo.cardName"
            class="main-color"
            :is-link="!(psgInfo.id && psgInfo.checkStatus == 0)"
            @click="!(psgInfo.id && psgInfo.checkStatus == 0) && (showCardType = !showCardType)"
            input-align="left"
            :disabled="psgInfo.id && psgInfo.checkStatus == 0"
            readonly
          />
          <van-action-sheet
            v-model="showCardType"
            :actions="CARD_TYPE"
            @select="cardTypeSelect"
          />

          <van-field
            :label="$t('D008','证件号码')"
            v-model="identy"
            @input="cardNumberInput"
            placeholder="与乘客证件号码一致"
            :disabled="psgInfo.id && psgInfo.checkStatus != 1"
            clearable
          />

          <!-- 国籍 -->
          <van-field
            v-if="nationShow"
            :label="$t('D017','国籍')"
            v-model="psgInfo.nationName"
            is-link
            @click="$refs['nation'].toggle()"
            input-align="left"
            readonly
          />
          <ld-nation
            ref="nation"
            @selected="nationSelect"
          />

          <van-field
            v-if="bornShow"
            :label="$t('D013','出生日期')"
            v-model="psgInfo.born"
            is-link
            @click="showDate = !showDate"
            input-align="left"
            readonly
          />
          <van-popup
            lock-scroll
            v-model="showDate"
            position="bottom"
          >
            <van-datetime-picker
              v-model="currentBornDate"
              type="date"
              :min-date="BORN_MIN"
              :max-date="BORN_MAX"
              @cancel="showDate = false"
              @confirm="bornSelect"
            />
          </van-popup>

          <van-field
            v-if="expiryDateShow"
            :label="$t('Q214','有效期')"
            v-model="psgInfo.expiryDate"
            is-link
            @click="showExpiryDate = !showExpiryDate"
            input-align="left"
            readonly
          />
          <van-popup
            lock-scroll
            v-model="showExpiryDate"
            position="bottom"
          >
            <van-datetime-picker
              v-model="expiryDate"
              type="date"
              :min-date="EXPIRY_MIN"
              :max-date="EXPIRY_MAX"
              @cancel="showExpiryDate != false"
              @confirm="expiryDateSelect"
            />
          </van-popup>

          <van-field
            type="text"
            max="13"
            clearable
            v-model="phoneNumber"
            @click="phoneNumberClick"
            :error-message="phoneErrMsg"
            label-class="two-line"
            placeholder="乘客本人手机号码"
          >
            <span slot="label">
              手机号码(+86)
            </span>
            <span
              slot="button"
              v-if="!psgInfo.passed"
              class="red"
              @click="toCheck"
            >
              去核验 <van-icon name="arrow" />
            </span>
          </van-field>

          <verificate
            ref="verificate"
            :psg-info="psgInfo"
            :type="TravelVerificateType[12306]"
            @refresh="comple"
          />

          <van-field
            v-if="emailShow"
            clearable
            label="电子邮箱"
            placeholder="请输入电子邮箱"
            :error-message="emailErrMsg"
            v-model="psgInfo.email"
          />
        </van-cell-group>

        <div
          class="mt5 font12 gray"
          style="padding: 0 20px"
        >
          <ul>
            <li
              style="list-style: disc;"
              class="red"
            >
              请认真核对信息并确认无误，否则将出现购票失败，无法乘车等情况
            </li>
            <li
              v-if="!psgInfo.id"
              style="list-style: disc; margin-top: 12px;"
            >
              12306规定已通过核验的常用乘客在添加后30天内不可删除 ; 每个账号最多添加15个常用乘客
            </li>
            <template v-if="psgInfo.id && !psgInfo.passed == 1">
              <li style="list-style: disc; margin-top: 12px;">
                根据铁路要求，为加强新冠肺炎防治工作，2月1日期，购票时需提供每一名乘车人本人使用的手机号，以便再需要时联络
              </li>
              <li style="list-style: disc; margin-top: 12px;">
                未成年/老人等重点旅客及无手机旅客，可提供监护人或能及时联系的亲友哦手机
              </li>
              <li style="list-style: disc; margin-top: 12px;">
                港澳台及外籍旅客可提供邮箱
              </li>
            </template>
          </ul>
        </div>

        <div class="pad">
          <ld-button
            main
            size="lg"
            @click.native="comple(true)"
          >
            {{ $t('B006','确定') }}
          </ld-button>
        </div>
      </div>
    </van-popup>

    <emp-list
      ref="empList"
      :cplx="10904"
      :element="element"
      radio
      @radioSelected="radioSelected"
    />

    <Rule
      :visibility.sync="psgNameDescShow"
      type="2"
    />
  </div>
</template>

<script>
import { Popup, ActionSheet, Cell, CellGroup, Field, DatetimePicker } from 'vant'
import { mapGetters } from 'vuex'
import { validators } from 'Utils/valid'
import { formatDate } from 'Utils/dateUtil'
import verificate from 'Components/ldEditPsg/verificate'
import ldNation from 'Components/ldNation'
import ldButton from 'Common/ldButton'
import empList from 'Components/ldEmpList/index.vue'
import TrainBookInteractor, { TravelVerificateType } from 'Domain/use-cases/train-book-interactor'
import { excludeSpecial } from 'Utils/string'
import Rule from 'Views/Tr/trQuery/trEdit/TrRule'
import { getIDcardInfo } from '@/business/utils/publicFun'

/**
 * 乘机人类型
 * @desc 12306预订专用
 */
export const PSG_TYPE = [
  {key: '0', name: '成人票' },
  {key: '1', name: '儿童' },
  {key: '2', name: '学生' },
]

/**
 * 身份证类型
 * @desc 火车票专用
 */
export const CARD_TYPE = [
  { key: '1', name: '身份证', row: 'idNumber' },
  { key: 'B', name: '护照', row: 'passport', periodRow: 'passportPeriod' },
  { key: 'C', name: '港澳居民来往内地通行证', row: 'otherNumber', periodRow: 'otherPeriod' },
  { key: 'G', name: '台湾居民来往大陆通行证', row: 'otherNumber', periodRow: 'otherPeriod' },
  { key: 'H', name: '外国人永久居留身份证', row: 'otherNumber', periodRow: 'otherPeriod' },
  { key: '2', name: '港澳台居民居住证', row: 'otherNumber', periodRow: 'otherPeriod' }
]

export default {
  name: 'EditPsg',
  components: {
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    ldButton,
    ldNation,
    verificate,
    empList,
    Rule,
  },
  props: {
    element:{
      type: String,
      default:''
    }
  },
  data() {
    return {
      isShow: false,
      showPsgType: false,
      showCardType: false,
      showDate: false,
      showExpiryDate: false,
      psgTypeName: PSG_TYPE[0].name,
      expiryDate: new Date(),
      currentBornDate: new Date(),
      BORN_MIN: new Date('1940-01-01'),
      BORN_MAX: new Date(),
      EXPIRY_MIN: new Date(),
      EXPIRY_MAX: new Date('2099-12-30'),
      PSG_TYPE, CARD_TYPE,
      psgNameDescShow: false,
      identy: '',
      phoneErrMsg: '',
      phoneNumber: '',
      emailErrMsg: '',
      psgInfo: {},
      TravelVerificateType
    }
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo',
      travelerList: 'tr/travelerList',
      userInfo:'userInfo'
    }),
    /**
     * 火车票 护照(B)、港澳居民来往内地通行证(C)、台湾居民来往大陆通行证(G)、外国人永久居留身份证(H) 要选
     */
    bornShow() {
      let valid = ['B', 'C', 'G', 'H']
      if (valid.indexOf(this.psgInfo.identyType) > -1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 火车票 护照(B)、港澳居民来往内地通行证(C)、台湾居民来往大陆通行证(G)、外国人永久居留身份证(H) 要选
     */
    expiryDateShow () {
      let valid = ['B', 'C', 'G', 'H']
      if (valid.indexOf(this.psgInfo.identyType) > -1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 火车票 护照(B) 要选
     */
    nationShow () {
      let valid = ['B']
      if (valid.indexOf(this.psgInfo.identyType) > -1) {
        return true
      } else {
        return false
      }
    },
    /**
     * 火车票 除身份证外、外国人永久居留身份证(H)、港澳台居民居住证(2) 要填
     */
    emailShow () {
      let valid = ['1', 'H', '2']
      if (valid.indexOf(this.psgInfo.identyType) === -1) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    phoneNumberClick() {
      if(this.phoneNumber && this.phoneNumber.indexOf('*') > -1) {
        this.phoneNumber = ''
      }
    },
    cardNumberClick() {
      if(this.identy && this.identy.indexOf('*') > -1) {
        this.identy = ''
      }
    },
    cardNumberInput (val) {
      val = excludeSpecial(val)
      this.$forceUpdate()
    },
    /**
     * 证件类型选择回调
     */
    cardTypeSelect(item) {
      this.showCardType = false
      this.identy = ''
      this.psgInfo.cardName = item.name
      this.psgInfo.identyType = item.key
    },
    /**
     * 出生日期选择回调
     */
    bornSelect(item) {
      this.showDate = false
      this.psgInfo.born = formatDate(item).date
    },
    /**
     * 有效期选择回调
     */
    expiryDateSelect(item) {
      this.showExpiryDate = false
      this.psgInfo.expiryDate = formatDate(item).date
    },
    /**
     * 国籍选择回调
     */
    nationSelect(city) {
      this.psgInfo.nationName = city.cName
      this.psgInfo.nation = city.by3
      this.$forceUpdate()
    },
    /**
     * 选择员工，回填员工信息
     */
    radioSelected (travel) {
      console.log(travel)
      this.psgInfo.name = this.$options.filters.getName(travel)
      this.identy = this.$options.filters.getIdNumber(travel)
      this.phoneNumber = travel.phoneNumber
      if (this.emailShow) this.psgInfo.email = travel.email
    },
    /**
     * 确定按钮
     * 回填乘车人信息
     */
    async comple(isConfirm = false) {
      if (this.phoneErrMsg !== '') return
      if (this.emailErrMsg !== '') return
      if (this.bornShow && !this.psgInfo.born) {
        this.$validErrorTips('出生日期不能为空')
        return
      }

      if (this.expiryDateShow && !this.psgInfo.expiryDate) {
        this.$validErrorTips('证件有效期不能为空')
        return
      }

      if (this.nationShow && !this.psgInfo.nationName) {
        this.$validErrorTips('国籍不能为空')
        return
      }

      if (this.emailShow && (!this.phoneNumber && !this.psgInfo.email)) {
        this.$validErrorTips('请填写联系手机/联系邮箱')
        return
      }

      /**
        * 证件号码填到对应字段
        */
      let type = CARD_TYPE.find(type => type.key == this.psgInfo.identyType)
      this.psgInfo[type.row] = this.identy

      // 身份证自动算出生日期和性别
      if (this.psgInfo.identyType == '1') {
        let idcardInfo = getIDcardInfo(this.identy)
        this.psgInfo.sex = idcardInfo.sex == '1' ? '0' : '1'
        this.psgInfo.born = idcardInfo.born
      }

      let params = {
        trainAccount: this.trSearchInfo['12306Info'].trainAccount,
        pass: this.trSearchInfo['12306Info'].password,
        contacts: {
          id: this.psgInfo.id || '0',
          name: this.psgInfo.name,
          sex: this.psgInfo.sex,
          birthday: this.psgInfo.born,
          country: this.psgInfo.nation,
          getValidDateEnd: this.psgInfo.expiryDate,
          identyType: this.psgInfo.identyType,
          identy: this.identy,
          personType: this.psgInfo.personType,
          phone: this.phoneNumber,
          email: this.psgInfo.email,
          desensitization: 1
        }
      }
      try {
        const { data = [] } = await this.$api['trQuery/saveClk'](params)
        this.psgInfo.yzm = data[0].captcha

        if (isConfirm) this.$emit('selected', this.psgInfo)

        if (data[0].isVerify == 0) {
          this.psgInfo.passed = true
          if (isConfirm) this.toggle()
        } else {
          this.toCheck()
        }

      } catch (error) {
        throw error
      }
    },
    async toCheck () {
      try {
        if (this.psgInfo.yzm) {
          this.$refs['verificate'].toggle(true)
        } else {
          this.comple()
        }
      } catch (error) {
        if (typeof error === 'string') this.$dialog.alert({ message: error })
      }
    },
    async deletePsg () {
      try {
        this.$dialog.confirm({
          title: '温馨提示',
          message: '确定删除该乘客吗？'
        }).then(async () => {
          await this.$api['trQuery/deleteClk']({
            passengerName: this.psgInfo.name,
            sex: this.psgInfo.sex,
            passengeType: this.psgInfo.personType,
            identyType: this.psgInfo.identyType,
            identy: this.identy,
            trainAccount: this.trSearchInfo['12306Info'].trainAccount,
            pass: this.trSearchInfo['12306Info'].password,
          })

          this.$dialog({ message: '删除成功！' }).then(() => {
            this.$emit('selected', this.psgInfo)
            this.toggle()
          })
        })

      } catch (error) {
        throw error
      }
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle(val) {
      this.isShow = !this.isShow
      if (val && this.isShow) {
        if (!val.personType) this.$set(val, 'personType', PSG_TYPE[0].key)
        if (!val.identyType) this.$set(val, 'identyType', CARD_TYPE[0].key)

        val.cardName = CARD_TYPE.find(type => type.key == val.identyType).name
        this.currentBornDate = val.born ? new Date(val.born) : new Date('1980-01-01')
        this.phoneNumber = val.phone
        this.identy = val.identy

        this.psgInfo = val
        console.log(this.psgInfo,'-psgInfo')
        this.$forceUpdate()
      }
    }
  },
  watch: {
    phoneNumber: function(val) {
      this.psgInfo.phoneNumber = excludeSpecial(val)
      if (val && !validators.mobile(val).valid) {
        this.phoneErrMsg = validators.mobile(val).msg
      } else {
        this.phoneErrMsg = ''
      }
    },
    'psgInfo.email': function(val) {
      if (val && !validators.email(val).valid) {
        this.emailErrMsg = validators.email(val).msg
      } else {
        this.emailErrMsg = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

@{deep}.van-field {
  .two-line {
    line-height: 14px;
  }

  &.main-color {
    .van-field__control {
      color: @color-text-main;
    }
  }
}

.pad {
  padding: 20px;
}

.mt5 {
  margin-top: 5px;
}

.pad8 {
  padding: 8px;
}

</style>
